module.exports = __webpack_public_path__ + "static/Google_Ads_Platform_Mockup-0146dc0934e012a005c40fc680aa66f7.jpg";